<template>
  <div class="tabs">
    <div class="tabs-main" :class="{ 'no-border': tabsName === '电子书刊' || tabsName === '数字报纸' }" @click="handleClick">
      <div class="tabs-main-left" :class="{ active: currentIndex === tabsIndex }">
        <div class="tabs-icon"></div>
        <div class="title">{{ tabsName }}</div>
      </div>
      <div class="icon-plus" v-show="isOpen"><span v-if="currentSidebarOpenIndex === tabsIndex && isShow">-</span><span v-else>+</span></div>
    </div>
    <div>
      <el-collapse-transition>
        <div v-if="subTabsList" v-show="currentSidebarOpenIndex === tabsIndex && isShow" class="sub-tabs">
          <div v-for="(tabsSubItem, tabsSubIndex) in subTabsList" v-show="!(tabsSubItem.name == '阅读数据' && booksCurrentSubAccount != '')" :key="tabsSubItem.name">
            <div class="transition-box" :class="{ active: currentSubIndex == tabsSubIndex && currentIndex == tabsSubItem.upIndex }" @click="toManage(tabsSubItem, tabsSubIndex)">
              {{ tabsSubItem.name }}
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>

<script>
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'
export default {
  name: 'tabs',
  data() {
    return {
      isShow: false,
      baseUrl: window.PROJECT_CONFIG.BASE_URL,
      baseUrl2: window.PROJECT_CONFIG.BASE_URL2,
      noBorderList: ['电子书刊', '我的积分']
    }
  },
  props: {
    type: { default: 'list', type: String },
    tabsName: String,
    isOpen: Boolean,
    url: String,
    subTabsList: Array,
    tabsIndex: Number,
    tabsComponent: String
  },
  components: {
    TipDialog
  },
  mixins: [compareVipRight],
  computed: {
    booksCurrentSubAccount() {
      return this.$store.state.manage.booksCurrentSubAccount
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    currentIndex() {
      return this.type === 'subAccount' ? this.$store.state.manage.currentSubAccountSidebarIndex : this.$store.state.manage.currentSidebarIndex
    },
    currentSidebarOpenIndex() {
      return this.$store.state.manage.currentSidebarOpenIndex
    },
    currentSubIndex: {
      get() {
        return this.$store.state.manage.currentSidebarSubIndex
      },
      set(value) {
        this.$store.commit('manage/UPDATE_SIDEBAR_SUBINDEX', value)
      }
    }
  },
  watch: {
    currentSidebarOpenIndex(val) {
      this.isShow = this.tabsIndex === val
    }
  },
  methods: {
    handleClick() {
      this.$store.commit('manage/UPDATE_SIDEBAR_OPEN_INDEX', this.tabsIndex)
      if (this.isOpen) {
        this.isShow = !this.isShow
      } else {
        if (this.tabsName === '阅读数据') {
          if (this.url) {
            window.location.href = this.baseUrl2 + this.url
          }
        } else {
          // 当前子账号管理页的导航仅有一项，暂不参与跳转路径管理，后续如果添加，主要不要添加到列表页的路径管理中（manage/UPDATE_SIDEBAR_INFO）
          if (this.type === 'subAccount') {
            return
            // this.$store.commit('manage/UPDATE_SUB_ACCOUNT_SIDEBAR_INFO', {
            //   index: this.tabsIndex,
            //   component: this.tabsComponent
            // })
          } else {
            this.$store.commit('manage/UPDATE_SIDEBAR_INFO', {
              index: this.tabsIndex,
              subIndex: -1,
              component: this.tabsComponent
            })
          }
        }
      }
    },
    async toManage(tab, index) {
      if (tab.name === '阅读数据') {
        if (tab.url) {
          window.location.href = this.baseUrl2 + tab.url
          return
        }
      }
      if (tab.name === '书刊默认效果') {
        this.$store.commit('book/UPDATE_IS_PAPER', false)
        this.$store.commit('config/UPDATE_PAPERSTYLE', false)
        if (!(await this.compareRight({ type: 'boole', key: 'defaultSetting' }))) {
          this.$refs.memberDialog.visible = true
          return
        }
      }
      if (tab.url === 'to') {
        this.$store.commit('manage/UPDATE_SIDEBAR_INFO', {
          index: this.tabsIndex,
          subIndex: index,
          component: tab.component
        })
        if (tab.id == '2' && this.tabsIndex == 0) {
          let componentManager = 'Published'
          this.$store.commit('manage/UPDATE_COMPONENTMANAGER', componentManager)
        }
        this.$store.commit('manage/UPDATE_COMPONENTMANAGER', 'Published')
        document.title = tab.upIndex === 2 ? '内容运营' : tab.upIndex === 1 ? '数字报纸' : '电子书刊'
      } else {
        //跳转到其他网页 url
        let a = document.createElement('a')
        a.href = this.baseUrl + tab.url
        a.click()
      }
    }
  },
  mounted() {
    if (this.currentSidebarOpenIndex === this.tabsIndex) {
      this.isShow = true
    }
  }
}
</script>

<style lang="scss">
.tabs {
  .tabs-main {
    height: 57px;
    margin: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.no-border {
      border-bottom: none;
    }
    .tabs-main-left {
      display: inline-flex;
      align-items: center;
      width: 70%;
      height: 100%;
      .tabs-icon {
        width: 20px;
        height: 20px;
        background-image: url('../../../assets/imgs/icon_sidebar.png');
        background-size: 20px 20px;
        margin-right: 9px;
      }
      .title {
        &:hover {
          color: #df5813;
        }
        &.active {
          color: #df5813;
        }
      }
      &:hover,
      &.active {
        .tabs-icon {
          background-image: url('../../../assets/imgs/icon_sidebar_active.png');
        }
        .title {
          color: #df5813;
        }
      }
    }
    .icon-plus {
      width: 30%;
      text-align: right;
      font-size: 18px;
      span {
        color: #df5813;
      }
    }
  }
  .sub-tabs {
    .transition-box {
      height: 42px;
      font-size: 14px;
      text-indent: 43px;
      line-height: 43px;
      border-left: 3px solid #fafafa;
      &:hover,
      &.active {
        color: #df5813;
        border-left: 3px solid #df5813;
        background-color: #f3f3f3;
      }
    }
  }
}
</style>
